declare global {
  interface Window {
    settings: {
      VITE_API_BASE_URL: string;
      VITE_ENVIROPMENT: string;
      VITE_SENTRY_DSN: string;
    };
  }
}

const runtimeConfig = {
  API_BASE_URL:
    window?.settings?.VITE_API_BASE_URL || import.meta.env?.VITE_API_BASE_URL,
  ENVIROPMENT:
    window?.settings?.VITE_ENVIROPMENT || import.meta.env?.VITE_ENVIROPMENT,
  SENTRY_DSN:
    window?.settings?.VITE_SENTRY_DSN || import.meta.env?.VITE_SENTRY_DSN,
};

export default runtimeConfig;
